import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import styles from './EditableHeader.module.css';

const EditableHeader = ({ className, children }) => {
  const { user, updateDashboardHeader } = useAuth();
  const { showSuccess, showError } = useToast();
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(user?.dashboardHeader || 'Academic Analytics');

  const handleEdit = () => {
    setIsEditing(true);
    setEditValue(user?.dashboardHeader || 'Academic Analytics');
  };

  const handleSave = async () => {
    if (!editValue.trim()) {
      showError('Dashboard header cannot be empty');
      return;
    }

    if (editValue.trim().length > 255) {
      showError('Dashboard header must be less than 255 characters');
      return;
    }

    const result = await updateDashboardHeader(editValue.trim());
    
    if (result.success) {
      showSuccess('Dashboard header updated successfully');
      setIsEditing(false);
    } else {
      showError(result.error || 'Failed to update dashboard header');
    }
  };

  const handleCancel = () => {
    setEditValue(user?.dashboardHeader || 'Academic Analytics');
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className={`${styles.editableHeader} ${className || ''}`}>
      {isEditing ? (
        <div className={styles.editContainer}>
          <input
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyPress}
            className={styles.editInput}
            autoFocus
            maxLength={255}
          />
          <div className={styles.editButtons}>
            <button
              onClick={handleSave}
              className={styles.saveButton}
              title="Save (Enter)"
            >
              ✓
            </button>
            <button
              onClick={handleCancel}
              className={styles.cancelButton}
              title="Cancel (Escape)"
            >
              ✕
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.displayContainer}>
          <span className={styles.headerText}>
            {user?.dashboardHeader || 'Academic Analytics'}
          </span>
          <button
            onClick={handleEdit}
            className={styles.editButton}
            title="Edit dashboard header"
          >
            ✏️
          </button>
        </div>
      )}
    </div>
  );
};

export default EditableHeader;
